export default () => {
  $('button[data-go-to-top]').click(function() {
    $(".menu-list__item").each((index, element) => {
      $(element).removeClass("menu-list__item--active-link");
    });

    $('html, body').animate({ scrollTop: 0 }, 500);
  });
};
